<template>
    <div>
        <app-nav />
        <main>
            <section>
                <div class="row d-flex justify-content-center m-0 p-0">
                    <div v-if="!loading" class="col taust w-100">
                        <div class="row d-flex mob-bg justify-content-center m-0 p-0 wow fadeIn">
                            <div class="col top-m-p text-center w-100">
                                <h1 class="display-5 font-weight-normal my-3">
                                    {{ offer.name[locale] }}
                                </h1>
                            </div>
                        </div>
                        <div class="container mt-2">
                            <app-card class="mb-3">
                                <div class="row mb-3 mt-3">
                                    <div v-if="offer.dbname" class="col-3">
                                        <img
                                            :src="`${envUrl}/offers/${offer.dbname}`"
                                            height="auto"
                                            class="img-thumbnail rounded z-depth-1 w-100"/>
                                    </div>
                                    <div class="col">
                                        <h4 class="text-center">{{ offer.name[locale] }}</h4>
                                        <p v-if="offer.discount_percent">{{ $t('Discount')}}: -{{ offer.discount_percent }}%</p>
                                        <!--                                        <p>{{ $t('Period') }}: {{ offer.start_date | formatDate }} - {{ offer.end_date | formatDate }}</p>-->
                                        <div v-html="offer.comments[locale]"/>
                                    </div>
                                </div>
                                <template v-if="offer.vehicles.length">
                                    <div class="mb-3" v-for="(vehicle, i) in offer.vehicles" :key="i">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-6 col-sm-12">
                                                <img
                                                    v-if="vehicle.imgs.length"
                                                    :src="`${envUrl}/vehicles/${vehicle.imgs[0].dbname}`"
                                                    height="auto"
                                                    class="img-thumbnail rounded z-depth-1 w-100"/>
                                                <div v-else class="special-img rounded z-depth-1">
                                                    <div class="view car-img" />
                                                </div>
                                            </div>
                                            <div class="col-lg-5 col-md-6 col-sm-12">
                                                <h4 class="dark-grey-text font-weight-normal">
                                                    {{ vehicle.make.name }} {{ vehicle.model.name }}
                                                </h4>
                                                <p class="dark-grey-text p-300-sm">
                                                    {{ $t(vehicle.transmission.name) }}
                                                    <br />
                                                    {{ $t(vehicle.fuel.name) }}
                                                </p>
                                            </div>
                                            <div class="col-lg-4 col-md-12 col-sm-12">
                                                <div class="d-flex justify-content-center align-items-start">
                                                    <router-link
                                                        :to="{
                                                            name: 'pub.booking',
                                                            params: { vehicle_slug: vehicle.slug },
                                                            query: { offer: offer.slug[locale] }
                                                        }"
                                                        class="btn btn-outline-autorent w-100">
                                                        {{ $t('Book now') }}
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </app-card>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <app-footer />
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import PublicSpecialOfferService from '@services/publicSpecialOffer.service';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            offer: {},
            loading: false
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        getSpecialOffer(slug) {
            this.loading = !this.loading;
            PublicSpecialOfferService.getSpecialOffer(slug).then(res => {
                this.offer = res;
                this.loading = !this.loading;
            });
        }
    },
    components: {
        AppNav,
        AppFooter
    },
    beforeRouteUpdate(to, from, next) {
        this.getSpecialOffer(to.params.special_slug);
        next();
    },
    created() {
        this.getSpecialOffer(this.$route.params.special_slug);
    }
};
</script>
